import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";
import { REVIEWS } from "../data/reviews";
import { getToolBySlug } from "../data/tools";

export default function ReviewsIndex() {
  return (
    <>
      <SEO title="AI Writing Tool Reviews" description="Hands-on, tested reviews of Phrasly.ai, Rytr, and Codex Leo AI — pricing, quality scores, and honest limitations." />
      <section className="pt-36 pb-20 px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-mono-tag text-xs uppercase tracking-[0.2em] text-gold mb-4">Reviews</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="font-display font-black text-4xl sm:text-5xl text-white tracking-tight max-w-2xl">Every Tool, Tested by Hand</motion.h1>
          <p className="text-zinc-400 mt-4 max-w-xl">No sponsored placements. Every review below is based on 12-30 days of real, hands-on testing with a paid account.</p>

          <div className="grid sm:grid-cols-2 gap-6 mt-14">
            {REVIEWS.map((r, i) => {
              const tool = getToolBySlug(r.toolSlug);
              return (
                <motion.div key={r.slug} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.5, delay: (i % 2) * 0.1 }}>
                  <Link to={`/reviews/${r.slug}`} className="group flex flex-col h-full border border-white/10 rounded-sm overflow-hidden hover:border-primary/50 transition-colors bg-surface/40">
                    <img src={r.heroImage} alt={tool?.name} className="w-full h-48 object-cover grayscale group-hover:grayscale-0 transition-all duration-500" />
                    <div className="p-6 flex-1 flex flex-col">
                      <div className="flex items-center gap-2 mb-3">
                        <span className="text-white font-display font-bold">{tool?.name}</span>
                        {tool?.editorsChoice && <span className="text-[10px] font-mono-tag uppercase px-2 py-0.5 rounded-full bg-gold/15 text-gold border border-gold/30">Editor's Choice</span>}
                        <span className="ml-auto flex items-center gap-1 text-sm text-silver"><Star className="w-3.5 h-3.5 fill-gold text-gold" aria-hidden="true" />{tool?.rating}</span>
                      </div>
                      <p className="text-zinc-400 text-sm leading-relaxed flex-1">{tool?.oneLiner}</p>
                      <p className="text-primary text-sm font-medium mt-4 inline-flex items-center gap-1 group-hover:gap-2 transition-all">Read full review <ArrowRight className="w-3.5 h-3.5" aria-hidden="true" /></p>
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
